import React, { useState, useCallback, useEffect } from 'react';
import {
  TextField,
  Container,
  FormGroup,
  Typography,
  Tooltip,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import ListItem from '@mui/material/ListItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Fab from '@mui/material/Fab';
import { DropzoneArea } from 'mui-file-dropzone';
import { useLocation } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import NumberFormat from 'react-number-format';
import InfoIcon from '@mui/icons-material/Info';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import Carousel from 'react-material-ui-carousel';
import { useStyles } from './Styles';
import { Autocomplete } from '@mui/lab';
import api from 'services/api';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const {
    children, classes, onClose, ...other
  } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function HandleWaterAnalysis(data) {
  const location = useLocation();
  const [title, setTitle] = useState('');
  const [qtdImagens, setqtdImagens] = useState(0);
  const [indexImage, setIndexImage] = useState(-1);
  const [indexParameter, setIndexParameter] = useState(-1);
  const [observation, setobservation] = useState('');
  const [images, setImages] = useState([]);
  const [dataOfImages, setDataOfImages] = useState(new Map());
  const [open, setOpen] = useState(false);
  const [openAddOrEdit, setOpenAddOrEdit] = useState(false);
  const [parameters, setParameters] = useState([]);
  const classes = useStyles();
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  let formData = new FormData();

  function Item(props) {
    return (
      <Paper variant="outlined" style={{ marginBottom: 25 }}>
        <img
          alt="item"
          style={{
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: 'auto',
          }}
          src={props.item.path !== undefined ? props.item.path : ''}
        />
      </Paper>
    );
  }

  useEffect(() => {
    // parameter_id,observation, value
    setParameters(data.parameters);
    setDataOfImages(dataOfImages);
  }, [data.parameters, data.samples, dataOfImages]);

  function handleClose() {
    setOpen(false);
  }

  function addImage() {
    const tempImages = dataOfImages.get(indexParameter);
    if (title !== '') {
      const temp = tempImages[indexImage];
      temp.title = title;
      temp.observation = observation;
      formData.append('file', images[indexImage]);
      api({
        method: 'post',
        url: '/upload',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then((response) => {
          formData = new FormData();

          temp.path = response.data.url;
          tempImages[indexImage] = temp;
          dataOfImages.set(indexParameter, tempImages);

          if (indexImage === qtdImagens - 1) updateImageSet();
        })
        .catch((response) => {
          // handle error
        });
    }
  }

  async function handleSetImageUrl(files) {
    const imgs = files;
    if (imgs.length > 0) {
      async function readerFiles(image) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(image);
        });
      }
      const tempImages = [];
      for (let i = 0; i < imgs.length; i++) {
        await readerFiles(imgs[i]).then((result) => {
          tempImages.push({
            title: 'Teste',
            path: '',
            image: result,
            observation: 'Teste',
          });
        });
      }

      dataOfImages.set(indexParameter, tempImages);
      setImages(imgs);

      //
    }
    /* const reader = new FileReader();

            reader.onload = () => {
              setPreview(reader.result);
              setImageUrl(null)
          }
          reader.readAsDataURL(img);

          setImageUrl((imageFile) => img); */
  }

  function updateImageSet() {
    setOpenAddOrEdit(false);

    function logMapElements(value, key, map) {
      return value.map((v) => ({
        title: v.title,
        path: v.path,
        observation: v.observation,
      }));
    }

    dataOfImages.forEach((value, key, map) => {
      const imageSet = { name: location.pathname + Date.now(), images: null };
      imageSet.images = logMapElements(value, key, map);

      data.parameters[key].imageSet = imageSet;
    });
    data.callback(parameters);
    forceUpdate();
  }

  function openDetailsImages() {
    setOpen(false);
    setOpenAddOrEdit(true);
    setIndexImage(0);
    setqtdImagens(images.length);
  }

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          size="small"
          aria-label="a dense table"
          sx={{
            '.MuiContainer-root': {
              padding: 0,
              pr: '8.125rem',
              pl: '8.9rem',
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>Parâmetro</TableCell>
              <TableCell align="center">{data.label}</TableCell>
              <TableCell align="center">Observações (Opcional)</TableCell>
              {data.dataOfImages && (
                <TableCell align="center">Imagem</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {parameters.map((row, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  {row.name ? row.name : row.parameter.name}
                </TableCell>
                <TableCell key={index}>
                  <ListItem dense>
                    <Container>
                      {!(row.hasOptions !== null && row.hasOptions !== undefined
                        ? row.hasOptions
                        : row.parameter.hasOptions) ? (
                          <FormGroup key={index}>
                            <NumberFormat
                              required
                              fullWidth
                              className={classes.textField}
                              margin="dense"
                              label={
                              row.unity
                                ? row.unity.sigla
                                : row.parameter.unity.sigla
                            }
                              variant="standard"
                              name="quantity"
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={6}
                              isAllowed={(inputObj) => inputObj.value <= 1000000}
                              allowNegative={false}
                              value={row.value}
                              onValueChange={(e) => {
                                row.value = e.floatValue;
                                data.callback(parameters);
                                forceUpdate();
                              }}
                              customInput={TextField}
                            />
                          </FormGroup>
                        ) : (
                          <FormGroup key={index}>
                            <Autocomplete
                              className={classes.textField}
                              noOptionsText="Sem opções"
                              name="options"
                              options={
                              row.options ? row.options : row.parameter.options
                            }
                              value={row.optionValue}
                              getOptionLabel={(option) => (option.observation ? option.observation : '')}
                              onChange={(p, v) => {
                                row.optionValue = v;
                                // alert(JSON.stringify(row))
                                data.callback(parameters);
                                forceUpdate();
                              }}
                              renderInput={(params) => (
                                <TextField
                                  variant="standard"
                                  required="true"
                                  {...params}
                                  label="Opções"
                                />
                              )}
                            />
                          </FormGroup>
                        )}
                    </Container>
                  </ListItem>
                </TableCell>
                <TableCell align="right">
                  <FormGroup>
                    <TextField
                      className={classes.textField}
                      variant="standard"
                      label={(
                        <div>
                          Descrição (Opcional)
                          <HtmlTooltip
                            title={
                              <>Digite aqui alguma informação importante.</>
                            }
                            placement="top"
                            arrow
                          >
                            <InfoIcon color="primary" fontSize="inherit" />
                          </HtmlTooltip>
                        </div>
                      )}
                      name="observation"
                      inputProps={{ maxLength: 100 }}
                      helperText={
                        row.observation?.length >= 100
                          ? 'Máximo de caracteres ultrapassado (100 caracteres permitido).'
                          : null
                      }
                      error={row.observation?.length >= 100}
                      type="text"
                      fullWidth
                      margin="dense"
                      value={row.observation}
                      onChange={(e) => {
                        row.observation = e.target.value;
                        data.callback(parameters);
                        forceUpdate();
                      }}
                    />
                  </FormGroup>
                </TableCell>
                {data.dataOfImages && (
                  <TableCell align="center" scope="row" component="th">
                    <>
                      <Fab
                        onClick={() => {
                          setTitle('');
                          setobservation('');
                          setIndexParameter(index);
                          setOpen(true);
                        }}
                        style={{ boxShadow: 'none', backgroundColor: '#fff' }}
                        component="span"
                        className={classes.buttonImage}
                      >
                        {dataOfImages.get(index) === undefined && !data.id && (
                          <AddPhotoAlternateIcon />
                        )}
                        <Paper variant="outlined" style={{ marginBottom: 25 }}>
                          <img
                            style={{
                              display: 'block',
                              maxWidth: '100%',
                              maxHeight: '100%',
                              width: 'auto',
                              height: 'auto',
                            }}
                            src={
                              data.id && data.parameters.length > 0
                                ? data.parameters[index].imageSet.images[0].path
                                : dataOfImages.get(index) !== undefined
                                  ? dataOfImages.get(index)[0].image
                                  : ''
                            }
                            alt="imagem"
                          />
                        </Paper>
                      </Fab>
                    </>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Imagens
        </DialogTitle>
        <DialogContent dividers>
          {data.id && data.parameters.length > 0 ? (
            <Carousel>
              {indexParameter !== -1
                && data.parameters[indexParameter].imageSet.images.map(
                  (item, i) => <Item key={i} item={item} />,
                )}
            </Carousel>
          ) : (
            <DropzoneArea
              acceptedFiles={['image/*']}
              onChange={(files) => handleSetImageUrl(files)}
              showFileNames
              dropzoneText="Arraste as imagens aqui ou clique para selecionar"
              showAlerts={false}
              filesLimit={5}
            />
          )}
        </DialogContent>
        <DialogActions>
          {indexParameter !== -1 ? (
            data.id && data.parameters.length > 0 ? (
              <Button
                autoFocus
                onClick={() => {
                  setOpen(false);
                }}
                color="primary"
              >
                Fechar
              </Button>
            ) : (
              <Button autoFocus onClick={openDetailsImages} color="primary">
                Adicionar
              </Button>
            )
          ) : null}
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openAddOrEdit}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Dados adicionais
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            value={title}
            required
            onChange={(e) => setTitle(e.target.value)}
            style={{ marginBottom: 15 }}
            fullWidth
            id="standard-basic"
            label="Titulo"
            variant="outlined"
          />
          <Paper variant="outlined" style={{ marginBottom: 25 }}>
            <img
              style={{
                display: 'block',
                maxWidth: '330px',
                maxHeight: '250px',
                width: 'auto',
                height: 'auto',
              }}
              src={
                indexImage !== -1
                  ? dataOfImages.get(indexParameter)[indexImage].image
                  : null
              }
              alt="imagem"
            />
          </Paper>
          <TextField
            id="outlined-multiline-static"
            label="Comentarios"
            value={observation}
            onChange={(e) => setobservation(e.target.value)}
            multiline
            rows={4}
            defaultValue=""
            required
            fullWidth
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Typography>
            {indexImage + 1}
            /
            {qtdImagens}
          </Typography>

          <Button
            autoFocus
            onClick={() => {
              if (indexImage > 0) {
                setIndexImage(indexImage - 1);
                setTitle(
                  dataOfImages.get(indexParameter) !== undefined
                    ? dataOfImages.get(indexParameter)[indexImage].title
                    : '',
                );
                setobservation(
                  dataOfImages.get(indexParameter) !== undefined
                    ? dataOfImages.get(indexParameter)[indexImage].observation
                    : '',
                );
              }
            }}
            color="primary"
          >
            Anterior
          </Button>
          {qtdImagens - 1 !== indexImage ? (
            <Button
              autoFocus
              onClick={() => {
                if (indexImage < qtdImagens) {
                  setIndexImage(indexImage + 1);
                  addImage();
                  setTitle('');
                  setobservation('');
                }
              }}
              color="primary"
            >
              Proximo
            </Button>
          ) : (
            <Button
              autoFocus
              onClick={() => {
                addImage();
              }}
              color="primary"
            >
              Adicionar
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
